import { dialogDefault, DIALOG_CLIENTE } from "../consts";

const mydialog = {...dialogDefault, editable: true}

export const openDialog = dialogInfo => ({
    type: DIALOG_CLIENTE,
    payload: dialogInfo
});

export default function clienteDialogReducer(state = mydialog, { type, payload }) {
    const actions = {
        [DIALOG_CLIENTE] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}